import { Route } from '@/router/types'
import { expressRoutes } from './express'
import { pathwayAdminRoutes } from './pathways'

export const adminRoutes: Route[] = [
  {
    path: '/admin/branded_caller_ids',
    name: '#adminBrandedCallerIds',
    component: () =>
      import(
        '@/legacy/components/admin/AdminBrandedCallerIds/AdminBrandedCallerIds.vue'
      ),
    meta: {
      title: 'Admin Edit Branded Caller Ids',
      permissionCheck: 'canEditOutboundGeorouting',
    },
  },

  {
    path: '/admin/care_plan_goals',
    name: '#adminEditCarePlanGoals',
    component: () =>
      import('@/pages/Admin/AdminCarePlanGoals/AdminCarePlanGoals.vue'),
    meta: {
      title: 'Admin Edit Care Plan Goals',
      permissionCheck: 'canEditAdminCarePlanGoalReferences',
    },
  },

  {
    path: '/admin/comorbidity_reference',
    name: '#adminComorbidityReference',
    component: () =>
      import('@/legacy/components/admin/AdminComorbidityReference.vue'),
    meta: {
      title: 'Admin Comorbidity Refererences',
      permissionCheck: 'canEditPatientAdminComorbidities',
    },
  },
  {
    path: '/admin/document_category',
    name: '#adminDocumentCategories',
    component: () =>
      import(
        '@/pages/Admin/AdminDocumentCategories/AdminDocumentCategories.vue'
      ),
    meta: {
      title: 'Admin Document Categories',
      permissionCheck: 'canEditDocumentCategories',
    },
  },
  {
    path: '/admin/omaat-enrollment',
    name: '#adminOmaatEnrollment',
    component: () =>
      import('@/pages/Admin/AdminOmaatEnrollment/AdminOmaatEnrollment.vue'),
    meta: {
      title: 'Debug OMAAT Enrollment Queue',
      permissionCheck: 'canViewPageEnrollmentLeadQueue',
    },
  },
  {
    path: '/admin/thyme_phone_numbers',
    name: '#adminThymePhoneNumbers',
    component: () => import('@/legacy/pages/AdminThymePhoneNumbers.vue'),
    meta: {
      title: 'Admin Thyme Phone Numbers',
      permissionCheck: 'canEditOutboundGeorouting',
    },
  },
  {
    path: '/admin/thyme_phone_number_configurations',
    name: '#adminThymePhoneNumberConfigurations',
    component: () =>
      import('@/legacy/pages/AdminThymePhoneNumberConfigurations.vue'),
    meta: {
      title: 'Admin Thyme Phone Number Configurations',
      permissionCheck: 'canEditOutboundGeorouting',
    },
  },
  {
    path: '/admin/users',
    name: '#adminUsers',
    component: () => import('@/pages/Admin/AdminUser/AdminUser.vue'),
    meta: {
      title: 'Admin Users',
      permissionCheck: 'canEditStaffRoles',
    },
  },
  {
    path: '/admin/care_pods',
    name: '#adminCarePods',
    component: () => import('@/legacy/components/admin/AdminCarePod.vue'),
    meta: {
      title: 'Admin Care Pods',
      permissionCheck: 'canViewPageAdminCarePods',
    },
  },
  ...pathwayAdminRoutes,
  ...expressRoutes,
]
